import { FC } from "react";
import './EpiAvatar.scss';

interface Props {
	name: string;
	color: string;
}

export function initialsOf(name: string) {
	const parts = (name || '').trim().split(/\s+/).filter(part => !!part);
	if (!parts.length) {
		return '?';
	}
	if (parts.length === 1) {
		return parts[0].substring(0, 2).toUpperCase();
	}
	return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

const EpiAvatar: FC<Props> = ({ name, color }) => (
	<span className="epi-avatar" style={{ backgroundColor: color }}>{initialsOf(name)}</span>
);

export default EpiAvatar;
